{
  "header": {
    "title": "Programación de preguntas",
    "description": "Revisar y analizar respuestas anteriores de retroalimentación"
  },
  "categorySection": {
    "title": "Distribución por categoría"
  }
}
